import { render, staticRenderFns } from "./supplierBZJ.vue?vue&type=template&id=768ada7d&scoped=true&"
import script from "./supplierBZJ.vue?vue&type=script&lang=js&"
export * from "./supplierBZJ.vue?vue&type=script&lang=js&"
import style0 from "./supplierBZJ.vue?vue&type=style&index=0&id=768ada7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ada7d",
  null
  
)

export default component.exports